import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector} from "react-redux";
import styles from "../Components/Header.module.css";
import Login from "../Components/Login";
import Logout from "../Components/Logout";
import { Link } from "react-router-dom";
//import axios from "axios";
import { itemsActions } from "../store/itemsSlice";
import {shopActions} from "../store/shopSlice";
import Api from "./Api";
import GeoLocationApi from "./GeoLocationApi";
import { deliveryCityactions } from "../store/deliveryCitySlice";
import NavBarMenu from "./NavBarMenu";
import { TfiLocationPin } from "react-icons/tfi";

function Header(props) {
  const textInput = useRef(null);
  let loggedInId = localStorage.getItem('user_id');
  const cssStyle = {textDecoration: "none"};
  const signinStyle = {textAlign:"center"};
  const logoStyle = {color:"red"};
  const bags = useSelector(store => store.bag.cartList);
  const [isAuth, setIsAuth] = useState(false);
  const [logout, setLogout] = useState(false);
  const [userName, setUserName] = useState('sign in');  
  const [isFocused, setIsFocused] = useState(false); 
  const dispatch = useDispatch();  
  useEffect(() => {  
    // if(localStorage.getItem('deliveryCity')==='defaultAll' || localStorage.getItem('deliveryCity')==null){
    //   alert('Please select your delivery city!!!');
    //   textInput.current?.focus();
    //   setIsFocused(true);
    // }     
    if (localStorage.getItem('access_token') !== null) {
      setIsAuth(true);
      Api.get(`/user-details/${loggedInId}/`)
        .then((response) => {
          setUserName(response.data[0].first_name);
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });      
    }   
    
  }, [isAuth]); 
  // This is for Logout component
  const handleLogout = () => {
    setLogout(true);
  }
  const handleKeyDown = (e) => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const shopId = params.get('shopid');
    if (e.key === 'Enter') {
      e.preventDefault();
      let valueBySearch = e.target.value;
      //console.log(valueBySearch);
      Api.get(`/search-products/${valueBySearch}/${shopId}`)
        .then((response) => {
          //console.log(response.data);
            dispatch(itemsActions.addInitialItems(response.data));
            dispatch(shopActions.addInitialItems(shopId));            
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
    }
  }
  const handleDeliveryCity = (e) => {
    //localStorage.removeItem('deliveryCity');
    //console.log(e.target.value);
    dispatch(deliveryCityactions.addInitialItems(e.target.value));    
    localStorage.setItem('deliveryCity',e.target.value);
  }  
  useSelector(store => store.deliveryCity);
  //console.log(deliveryCity)
  const slectedDeliveryCity = localStorage.getItem('deliveryCity') ?? 'defaultAll';  
    
  return <>
    {logout && <Logout />}
    <Login />    
    
    <header className="p-3 text-bg-dark">      
    <div className="container">
      <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
           
        <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
          <li><Link to="/" style={cssStyle}><img src={`${global.config.live_url}/images/menastockinstore-logo.png`} width="250" /></Link></li>        
          {/* <li className={`${styles.bigBag}`}><Link to="/" style={cssStyle}><span style={logoStyle}>mena</span>stockinstore</Link></li> */}
          {/*<li className={`${styles.deliveryTime}`}>Next Day Delivery</li>*/}
          {/* <li className={`${styles.deliveryTime}`}><GeoLocationApi /></li> */}          
          
        </ul>
        {/* <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
          <li className={`nav-item ${styles.cityDeliveryLocation}`}><TfiLocationPin /></li>
            <li className="nav-item">
              <form>
                <select className="form-select" aria-label="Default select example" onChange={handleDeliveryCity} ref={textInput} style=
                {
                    {
                        backgroundColor: isFocused ?
                            'antiquewhite' : 'white',
                            borderRadius: "5px"
                    }
                }>
                  <option value='defaultAll' selected="selected">Select your delivery city</option>
                  <option value="Faridabad" selected={`${slectedDeliveryCity}`==='Faridabad' ? 'selected' : ''}>Faridabad</option>
                  <option value="Gaya" selected={`${slectedDeliveryCity}`==='Gaya' ? 'selected' : ''}>Gaya</option>
                  <option value="Kolkata" selected={`${slectedDeliveryCity}`==='Kolkata' ? 'selected' : ''}>Kolkata</option>
                  <option value="Mira Road" selected={`${slectedDeliveryCity}`==='Mira Road' ? 'selected' : ''}>Mira Road</option>
                </select>
              </form>
            </li>
                </ul> */}
        
        <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" role="search">
          <input type="search" className={`form-control ${styles.inputProductSearch}`} placeholder="Search for" aria-label="Search" onKeyDown={handleKeyDown} />
        </form>

        <div className="text-end">
        { isAuth ? <><div class="btn-group">
  <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    Hello, {userName}
  </button>
  <ul class="dropdown-menu">
  <li style={signinStyle}>
  <button type="button" className="btn btn-warning" onClick={handleLogout}>Logout</button></li>  
  <li><hr class="dropdown-divider" /></li> 
  <li style={signinStyle}>Your Account</li>  
  <li style={signinStyle}><Link to="/your-profile" style={cssStyle}>Your Profile</Link></li>
  <li style={signinStyle}><Link to="/your-orders" style={cssStyle}>Your Orders</Link></li> 
  </ul>
</div> </> : <><div class="btn-group">
  <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    Hello, {userName}
  </button>
  <ul class="dropdown-menu">
  <li style={signinStyle}>
  <button type="button" className="btn btn-warning" data-bs-toggle="modal" data-bs-target="#myModal">Login</button></li>
  <li style={signinStyle}><Link to="/sign-up" style={cssStyle}>New user? SignUp</Link></li>
  <li><hr class="dropdown-divider" /></li>    
  </ul>
</div> </> } <button type="button" className="btn btn-light">{bags.length>0 ? <Link to="/bag" style={cssStyle}>Cart Items ({ bags.length})</Link> : <>Cart Items ({ bags.length})</>}</button>
        
          
        </div>
      </div>
    </div>
  </header>
  <NavBarMenu />
      </>
    
}
export default Header;